// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2cbms","bigColWidth":"Table_bigColWidth__3x0L7","biggerColWidth":"Table_biggerColWidth__3m_9k","row":"Table_row__t6aeA","col":"Table_col__10ywc"};